module.exports = __webpack_public_path__ + "images/file_icons_v2/ini-fad6a767d20f9e2de7c86f52d0648649.svg";